import type {components} from './contracts';
export type CreatorLease=components['schemas']['CreatorRenderLease'];
export type PrivateBootstrap={lease:CreatorLease;bootstrapTicket:string};
declare const privateCapability:unique symbol;
export type PrivateCapability={readonly [privateCapability]:true};
/** One in-memory slot. The public capability contains no serializable authority. */
export class CreatorBootstrapVault {
 private slot?:{capability:PrivateCapability;sourceId:string;attemptId:string;value:PrivateBootstrap};
 stage(sourceId:string,attemptId:string,value:PrivateBootstrap):PrivateCapability{
  if(this.slot||!sourceId||!attemptId||!/^[-_A-Za-z0-9]{43}$/.test(value.bootstrapTicket)||!Number.isFinite(Date.parse(value.lease.expiresAt))||Date.parse(value.lease.expiresAt)<=Date.now())throw Error('creator_unavailable');
  const capability=Object.freeze(Object.create(null)) as PrivateCapability;this.slot={capability,sourceId,attemptId,value:{lease:structuredClone(value.lease),bootstrapTicket:value.bootstrapTicket}};return capability;
 }
 take(capability:PrivateCapability,sourceId:string,attemptId:string,signal:AbortSignal):PrivateBootstrap{
  const slot=this.slot;this.slot=undefined;if(!slot||slot.capability!==capability||slot.sourceId!==sourceId||slot.attemptId!==attemptId||signal.aborted||Date.parse(slot.value.lease.expiresAt)<=Date.now())throw Error('creator_unavailable');return slot.value;
 }
 retire(attemptId:string){if(this.slot?.attemptId===attemptId)this.slot=undefined;}
}
